import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    expense_group_transform_batch,
    expense_group_write_off,
    batch_pass_user_flow_node_user
 } = util.api || {}

 export function saveExpenseGroupTransformBatchApi(params) {
    return http.post(expense_group_transform_batch, params)
}

export function createExpenseGroupWriteOffApi(params) {
    return http.post(expense_group_write_off, params)
}

export function batchPassApi(params) {
    return http.post(batch_pass_user_flow_node_user, params)
}
